module.exports = [{"type":"title","text":"2024-05-23"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual New Interface: Query Position and Maintenance Margin Ratio."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-05-23.json
// module id = wQ5t
// module chunks = 3